export default __webpack_public_path__ + "static/media/Icon-save.1762edee.svg";